export const DEFAULT_CALENDAR_YEAR_RANGE = {
  backward: 2,
  forward: 7
};
